<template>
	<div id="App">
		<router-view />
	</div>
</template>

<style lang="scss">
	@import url('./assets/css/zero.min.css');
	@import './assets/css/index.scss';
	// @import './assets/css/theme.scss';
</style>